<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>ICEGATE 05 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>SB No (6845161)<b-badge variant="light" v-b-tooltip.hover title="Shipping Bill Number">?</b-badge></label>
          <input v-model="sbNo" class="form-control" placeholder="e.g. 6845161" />
        </b-col>
        <b-col md="3">
          <label>SB Date(02042016) <b-badge variant="light" v-b-tooltip.hover title="Format: DDMMYYYY">?</b-badge></label>
          <input v-model="sbDt" class="form-control" placeholder="e.g. 02042016" />
        </b-col>
        <b-col md="3" class="align-self-end">
          <b-button v-if="sbNo && sbDt" @click="getAllICEGATE05Func()" size="sm" variant="primary">
             Fetch
          </b-button>
        </b-col>
      </b-row>

      <b-alert v-if="errorMsg" variant="danger" dismissible>{{ errorMsg }}</b-alert>

      <b-card v-if="!isLoading && (sbNo && sbDt) && (getAllICEGATE05.sbNo)" class="mt-4 shadow">
        <b-row>
          <b-col md="6" class="mb-2">
            <b>SB No:</b>
            <span>{{ getAllICEGATE05.sbNo || (getAllICEGATE05.sbNo) || sbNo }}</span>
            <b-button size="sm" variant="outline-secondary" @click="copyToClipboard(getAllICEGATE05.sbNo || (getAllICEGATE05.data && getAllICEGATE05.data.sbNo))" v-b-tooltip.hover title="Copy SB No">
              
            </b-button>
          </b-col>
          <b-col md="6" class="mb-2">
            <b>SB Date:</b> <span>{{ getAllICEGATE05.sbDt || (getAllICEGATE05.sbDt) || sbDt }}</span>
          </b-col>
          <b-col md="6" class="mb-2">
            <b>Unit of Quantity:</b>
            <span :class="{'text-danger': !(getAllICEGATE05.unitOfQt)}">
              {{ getAllICEGATE05.unitOfQt || 'N/A' }}
            </span>
          </b-col>
           <b-col md="6" class="mb-2">
            <b>Nature of Cargo:</b>
            <span :class="{'text-danger': !(getAllICEGATE05.natureOfCargo)}">
              {{ getAllICEGATE05.natureOfCargo || 'N/A' }}
            </span>
          </b-col>
           <b-col md="6" class="mb-2">
            <b>No of Packages:</b>
            <span :class="{'text-danger': !(getAllICEGATE05.noOfPkgs)}">
              {{ getAllICEGATE05.noOfPkgs || 'N/A' }}
            </span>
          </b-col>
           <b-col md="6" class="mb-2">
            <b>Port of Destination:</b>
            <span :class="{'text-danger': !(getAllICEGATE05.portOfDest)}">
              {{ getAllICEGATE05.portOfDest || 'N/A' }}
            </span>
          </b-col>
            <b-col md="6" class="mb-2">
            <b>Gross Quantity:</b>
            <span :class="{'text-danger': !(getAllICEGATE05.grossQt)}">
              {{ getAllICEGATE05.grossQt || 'N/A' }}
            </span>
          </b-col>
        </b-row>
      </b-card>

      <b-alert v-if="!isLoading && (sbNo && sbDt) && !(getAllICEGATE05.sbDt)" variant="warning" class="mt-4">
        No LEO Date found for this SB No and Date.
      </b-alert>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection.js";
export default {
  beforeMount() {
    this.$store.dispatch(
      "commonDropdownMaster/setAllVehicleDDList",
      JSON.stringify({
        itemCode: "getVehicleList",
        vehicleActiveInactiveId: "1",
      })
    );
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllICEGATE05Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      sbNo: '',
      sbDt: '',
      getAllICEGATE05: {},
      isLoading: false,
      error: false,
      errorMsg: '',
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() { },

  beforeDestroy() { },

  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  computed: {
    leoDtDisplay() {
      // Try to get from xmlJson, then from getAllICEGATE05.response.response[0].response.leoDt
      if (this.getAllICEGATE05 && this.getAllICEGATE05.xmlJson && this.getAllICEGATE05.xmlJson.leoDt) {
        return this.getAllICEGATE05.xmlJson.leoDt;
      }
      if (
        this.getAllICEGATE05 &&
        this.getAllICEGATE05.response &&
        this.getAllICEGATE05.response.response &&
        Array.isArray(this.getAllICEGATE05.response.response) &&
        this.getAllICEGATE05.response.response[0] &&
        this.getAllICEGATE05.response.response[0].response &&
        this.getAllICEGATE05.response.response[0].response.leoDt
      ) {
        return this.getAllICEGATE05.response.response[0].response.leoDt;
      }
      return '';
    },
  },

  methods: {
    async getAllICEGATE05Func() {
      let payload = {};
      this.isLoading = true;
      this.errorMsg = '';
      this.getAllICEGATE05 = {};

      if (this.sbNo && this.sbDt) {
        payload = {
          itemCode: "ICEGATE05",
          funcUrl: "ICEGATE/05",
          sbNo: this.sbNo,
          sbDt: this.sbDt,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status } = response;
            if (status == 200 && data) {
              if (data.xmlJson) {
                this.getAllICEGATE05 = data.xmlJson;
              } else {
                this.getAllICEGATE05 = data;
              }
            } else {
              this.errorMsg = 'No data found for this SB No and Date.';
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.errorMsg = 'Error fetching data. Please try again.';
            this.isLoading = false;
          });
      }
    },
    copyToClipboard(value) {
      if (!value) return;
      navigator.clipboard.writeText(value);
      this.$bvToast && this.$bvToast.toast('Copied to clipboard!', {
        title: 'Copied',
        variant: 'success',
        solid: true,
        autoHideDelay: 1500
      });
    }
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// ICEGATE05_ResponseDisplay.vue?3e478025